module.exports = __webpack_public_path__ + "img/bj6.f898e753.png";